import { render } from "./TransactionNotification.vue?vue&type=template&id=9537ff62&scoped=true"
import script from "./TransactionNotification.vue?vue&type=script&lang=js"
export * from "./TransactionNotification.vue?vue&type=script&lang=js"

import "./TransactionNotification.vue?vue&type=style&index=0&id=9537ff62&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9537ff62"]])

export default __exports__